module.exports = __webpack_public_path__ + "static/media/majorC3.fcdb752.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorC3.wav
// module id = +CU1
// module chunks = 0